import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'project-new',
  templateUrl: 'project-new.component.html',
  standalone: false
})

export class ProjectNewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector("body").classList.remove("opened");
  }
} 